import {
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoFlexAlignEnd,
    RaikoButtonPrimary,
    showSuccessMessage,
    showErrorMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components"
import {css} from "@emotion/css";
import React, {useState} from "react";
import {NotificationsService} from "../../serverService/notificationsService/NotificationsService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import CustomHtmlTextEditor from "../../component/magazine/CustomHtmlTextEditor";
import RaikoTextEditor from "../../raikoComponents/raikoTextEditor/RaikoTextEditor";
import {stringIsEmpty} from "../../util/VariableChecker";
import AdvanceRichEditor from "../../raikoComponents/raikoEditor/raikoRichEditor/AdvanceRichEditor";


export default function AddNewNotification({handleAddNewNotification}) {

    const [title, setTitle] = useState("")
    const [writerName, setWriterName] = useState("")
    const [text, setText] = useState("")
    const [enabled, setEnabled] = useState(true)
    const [buttonLoading, setButtonLoading] = useState(false)

    const service = new NotificationsService()

    function handleAddNewNotificationToServer() {
        if (checkFields()) {
            setButtonLoading(true)
            service.addNewNotification(title, writerName, text, enabled).then(
                response => {
                    showSuccessMessage("اطلاعیه جدید با موفقیت افزوه شد.")
                    handleAddNewNotification(response)
                }
            ).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setButtonLoading(false)
            })
        }
    }

    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(title))
            message = "لطفا نام اطلاعیه را وارد نمایید."
        else if (stringIsEmpty(writerName))
            message = "لطفا نام نویسنده را وارد نمایید."
        else if (stringIsEmpty(writerName))
            message = "لطفا متن اطلاعیه را وارد نمایید."
        else
            state = true


        if (message)
            showWarningMessage(message)


        return state

    }


    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoGridTwoColumn>
                <RaikoMaterialOutlinedInput
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                />
                <RaikoMaterialOutlinedInput
                    labelText={"نام نویسنده"}
                    value={writerName}
                    setValue={setWriterName}
                />
            </RaikoGridTwoColumn>
            <RaikoGridOneColumn>
                <AdvanceRichEditor
                    text={text}
                    setText={setText}
                />
            </RaikoGridOneColumn>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary
                    label={"افزودن"}
                    loading={buttonLoading}
                    onClick={handleAddNewNotificationToServer}
                />
            </RaikoFlexAlignEnd>

        </RaikoGridOneColumn>
    )
}